import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Divider, Button, message } from 'antd';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { MyCard } from '../../users/users-list/by-usertype/ByUserType';
import { getWithdrawalRequestsPayoutStatus } from '../../methods/redux/reducers/withdrawal-requests';

const MainPage = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 10px;

	& > div {
		display: flex;
		flex-direction: column;
		margin-right: 15px;

		& .label {
			color: #aaa;
			font-style: italic;
			font-size: 10px;
		}
		& .value {
			font-size: 16px;
		}
	}

	& .details {
		padding: 15px 0;

		& > * {
			display: inline-block;
			min-width: 200px;
			margin-bottom: 7px;
			padding: 5px;
		}

		& .label {
			font-size: 13px;
			color: #808080;
			font-style: italic;
		}
	}
`;

type Props = { requestIdProp?: string };

const SingleWithdrawalRequestPayoutStatus = ({ requestIdProp }: Props) => {
	const dispatch = useAppDispatch();
	const { withdrawalRequestsPayoutStatus } = useAppSelector(
		(store) => store.withdrawalRequests
	);
	const [searchParams] = useSearchParams();
	const getQueryParams = () => Object.fromEntries(searchParams.entries());
	const { requestId: queryRequestId } = getQueryParams();
	const requestId = requestIdProp ?? queryRequestId;

	useEffect(() => {
		if (!requestId) return;
		dispatch(getWithdrawalRequestsPayoutStatus(requestId));
	}, [requestId, dispatch]);

	// copy payment gateway payout status JSON to clipboard
	const copyPaymentGatewayJson = async () => {
		try {
			const json = JSON.stringify(
				withdrawalRequestsPayoutStatus?.paymentGatewayPayoutStatus ?? {},
				null,
				2
			);
			if (navigator?.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(json);
				message.success('Payment gateway JSON copied to clipboard');
			} else {
				// fallback
				const el = document.createElement('textarea');
				el.value = json;
				document.body.appendChild(el);
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);
				message.success('Payment gateway JSON copied to clipboard');
			}
		} catch (err) {
			console.error('Failed to copy JSON', err);
		}
	};

	return (
		<MyCard title="" style={{ margin: '20px' }}>
			<MainPage>
				<div>
					{withdrawalRequestsPayoutStatus?.paymentGatewayPayoutStatus && (
						<>
							<Divider />
							<br />
							<h3>Payment Gateway Payout Status</h3>
							<div className="details">
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										marginBottom: 8,
									}}
								>
									<span style={{ fontStyle: 'italic', color: '#666' }}>
										Rendered as JSON — structure may change
									</span>
									<Button size="small" onClick={copyPaymentGatewayJson}>
										Copy JSON
									</Button>
								</div>
								<details
									style={{
										background: '#fbfbfb',
										border: '1px solid #eee',
										padding: 12,
										borderRadius: 6,
										overflow: 'auto',
									}}
									open
								>
									<summary style={{ cursor: 'pointer', marginBottom: 8 }}>
										View raw JSON
									</summary>
									<pre
										style={{
											whiteSpace: 'pre-wrap',
											wordBreak: 'break-word',
											fontSize: 12,
											lineHeight: '1.4',
											margin: 0,
										}}
									>
										{JSON.stringify(
											withdrawalRequestsPayoutStatus.paymentGatewayPayoutStatus,
											null,
											2
										)}
									</pre>
								</details>
							</div>
						</>
					)}
					<Divider />
				</div>
			</MainPage>
		</MyCard>
	);
};

export default SingleWithdrawalRequestPayoutStatus;
